import React from 'react';
import StyledWrapper from './ToggleButtonStyles';

export interface ToggleButtonProps {
  text?: string;
  isActive?: boolean;
  onClick?: object;
}

const ToggleButton: React.FC<ToggleButtonProps> = ({
  text,
  isActive,
  onClick,
}) => {
  return (
    // @ts-ignore
    <StyledWrapper isActive={isActive} onClick={onClick}>
      <span>{text}</span>
    </StyledWrapper>
  );
};

export default ToggleButton;
